export default __webpack_public_path__ + "static/media/linkedIn_grey.b98ce40d.svg";